import React from 'react'
import { useNavigate } from 'react-router-dom'
import styles from "./Style.module.css"
import NoTimes from '../../Assets/Images/no-availability.svg'
import OutletCTA from '../OutletCTA/OutletCTA'
// import { BtnPrimary } from '../Buttons/BtnPrimary'

export const NoAvailability = ({phoneNum, whatsappNum}) => {
  const navigate = useNavigate()

  const handleTryDifferentService = () => {
    navigate('/select-services')
  }

  return (
    <div className={styles.noAvailability}>
        <img src={NoTimes} className={styles.icon} alt='' />
        <h5>No Availability</h5>
        <p>Let our friendly staff assist you with your booking.</p>
         {/* <div className={styles.tryDifferentServiceContainer}>
          <BtnPrimary
            label="Select Different Service"
            handleClick={handleTryDifferentService}
            customClass={styles.tryDifferentServiceBtn}
          />
        </div> */}
        <OutletCTA
        whatsappNumber={whatsappNum}
        contactNumber={phoneNum}
        customClass={styles.noAvailabilityCta}
        />
    </div>
  )
}
